export function pageVisible(): boolean {
  return document.visibilityState === 'visible';
}

/** Report every page visibility change; returns the unsubscribe. */
export function onVisibilityChange(listener: (visible: boolean) => void): () => void {
  const report = () => listener(pageVisible());
  document.addEventListener('visibilitychange', report);
  return () => document.removeEventListener('visibilitychange', report);
}

/**
 * Call `onResume` whenever the page may have been suspended: a back-forward cache restore or
 * a visibility change. Screens use it to refresh time-dependent state; returns the unsubscribe.
 */
export function onPageResume(onResume: () => void): () => void {
  window.addEventListener('pageshow', onResume);
  document.addEventListener('visibilitychange', onResume);
  return () => {
    window.removeEventListener('pageshow', onResume);
    document.removeEventListener('visibilitychange', onResume);
  };
}
